import React from 'react';
/**
 * Top breadcrumb trail for the Daedo PSS Systems category page.
 * Self-contained: not shared with other pages.
 */
export function Breadcrumb() {
  return <nav className="text-sm text-gray-500 mb-4" aria-label="Breadcrumb" data-id="element-194">
      <a href="/" className="hover:text-gray-900" data-id="element-195">
        Home
      </a>
      <span className="mx-2" data-id="element-196">/</span>
      <a href="/shop/" className="hover:text-gray-900" data-id="element-197">
        Shop
      </a>
      <span className="mx-2" data-id="element-198">/</span>
      <span className="text-gray-900 font-medium" data-id="element-199">Daedo PSS Systems</span>
    </nav>;
}